export default {"src":"/_next/static/media/growth-lg.mono.62f1eff7.svg","height":233,"width":364,"blurWidth":0,"blurHeight":0};